import Layout from './Layout.js';

export default class Column extends Layout {
  constructor() {
    super('div', 'muigui-row');
  }
}
